import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@izicvs/ui";
import { cn } from "@izicvs/utils";
import { t } from "@lingui/macro";
import { CaretDown, DownloadSimple, MagicWand, Plus } from "@phosphor-icons/react";
import { useNavigate } from "react-router";

import { useDialog } from "@/client/stores/dialog";

// The three ways to start a resume: blank (the /create wizard), AI, or import.
const useNewResumeActions = () => {
  const navigate = useNavigate();
  const { open: openAi } = useDialog("ai");
  const { open: openImport } = useDialog("import");

  return {
    onBlank: () => void navigate("/create"),
    onAi: () => {
      openAi("create");
    },
    onImport: () => {
      openImport("create");
    },
  };
};

const NewResumeItems = () => {
  const { onBlank, onAi, onImport } = useNewResumeActions();

  return (
    <>
      <DropdownMenuItem onClick={onBlank}>
        <Plus size={14} className="mr-2" />
        {t`Blank resume`}
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onAi}>
        <MagicWand size={14} className="mr-2" />
        {t`Create with AI`}
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onImport}>
        <DownloadSimple size={14} className="mr-2" />
        {t`Import a resume`}
      </DropdownMenuItem>
    </>
  );
};

// Desktop: a split button. Main action opens the wizard; the caret reveals the
// AI and import shortcuts.
export const NewResumeButton = ({ className }: { className?: string }) => {
  const { onBlank } = useNewResumeActions();

  return (
    <div className={cn("flex items-center", className)}>
      <Button className="flex-1 rounded-r-none pr-3" onClick={onBlank}>
        <Plus className="mr-1.5 size-4" weight="bold" />
        {t`New resume`}
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className="rounded-l-none border-l border-primary-foreground/20 px-2">
            <CaretDown className="size-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <NewResumeItems />
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

// Mobile: a thumb-reachable floating action button with the same shortcuts.
export const NewResumeFab = ({ className }: { className?: string }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        size="icon"
        className={cn("fixed bottom-6 right-6 z-40 size-14 rounded-full shadow-lg", className)}
      >
        <Plus className="size-6" weight="bold" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent side="top" align="end">
      <NewResumeItems />
    </DropdownMenuContent>
  </DropdownMenu>
);
